module.exports = __webpack_public_path__ + "img/17.d105eec0.png";